import { useState } from 'react'

import { MissionsFeed } from '@/features/missions'
import {
  FeedCard,
  FeedModal,
  MyProfileContent,
  MyProfileModal,
  UserCosmeticAvatar
} from '@/features/profiles'
import { useModalContext } from '@/shared/contexts/Modal'
import { useBreakpoints } from '@/shared/hooks/useBreakpoints'
import { useWallet } from '@/shared/hooks/useWallet'
import { cn } from '@/shared/lib/utils'
import { AnimatedNumber } from '@/shared/ui/AnimatedNumber'


interface ShellTopbarProps {
  className?: string
}

export const ShellTopbar = ({ className = '' }: ShellTopbarProps) => {
  const { isAtLeast } = useBreakpoints()
  const { points, coins } = useWallet()
  const { openModal } = useModalContext()
  const [rightSidebarTab, setRightSidebarTab] = useState<
    'feed' | 'user-profile'
  >('feed')

  const handleOpenFeed = () => {
    if (isAtLeast('lg')) setRightSidebarTab('feed')
    else openModal({ modal: FeedModal })
  }

  const handleOpenUserProfile = () => {
    if (isAtLeast('lg')) setRightSidebarTab('user-profile')
    else openModal({ modal: MyProfileModal })
  }

  return (
    <div className={cn('px-4 w-full', className)}>
      <div className="flex gap-2 items-center py-0.5 ">
        <div className="flex gap-2 items-center inset-shadow-[0_4px_4px_0_rgba(0,0,0,0.45)] rounded-lg px-3 py-1.5 bg-background">
          <img src="/icons/star.svg" alt="" className="size-7" />
          <AnimatedNumber
            value={points}
            className="text-white font-semibold font-sans"
          />
          <div className=""></div>
          <img src="/icons/coin.svg" alt="" className="size-7" />
          <AnimatedNumber
            value={coins}
            className="text-white font-semibold font-sans"
          />
        </div>
        {/* Same opaque pill grammar as the points/coins group on the left.
            On mobile this bar floats over the page with no background of its
            own, so without a surface here the page content scrolls up behind
            the bell and the avatar and makes them unreadable. */}
        <div className="flex gap-1 items-center ms-auto inset-shadow-[0_4px_4px_0_rgba(0,0,0,0.45)] rounded-lg px-1 bg-background">
          <div
            className="px-2 py-1.5 rounded-lg border-2 border-transparent cursor-pointer hover:bg-white/10 transition-colors duration-200"
            onClick={handleOpenFeed}
          >
            <span className="relative">
              {/* <span
                className="absolute
                top-0 right-0 inline-flex items-center justify-center w-2 h-2 bg-red-500 rounded-full border-1 border-white dark:border-gray-800 translate-x-1/2 -translate-y-1/2"
                aria-label="Notification badge"
              /> */}
              <img src="/icons/notification.svg" alt="" className="size-7" />
            </span>
          </div>
          <div
            className="px-2 py-1.5 rounded-lg border-2 border-transparent cursor-pointer hover:bg-white/10 transition-colors duration-200"
            onClick={handleOpenUserProfile}
          >
            <UserCosmeticAvatar size="xs" />
          </div>
        </div>
      </div>
      {isAtLeast('lg') && (
        <div id="right-sidebar" className="flex flex-col gap-8 mt-0 ">
          {rightSidebarTab === 'feed' && (
            <>
              <MissionsFeed />
              <FeedCard />
            </>
          )}
          {rightSidebarTab === 'user-profile' && (
            <MyProfileContent variant="card" />
          )}
        </div>
      )}
    </div>
  )
}
